import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cb80766"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Status history", -1 /* HOISTED */))
const _hoisted_4 = { style: {"margin-left":"5px","font-size":"small","font-weight":"100","margin-top":"0.7px"} }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = {
  key: 0,
  class: "row q-ma-lg"
}
const _hoisted_8 = { class: "selected-status q-mt-sm" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(") ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_StatusTimelineChart = _resolveComponent("StatusTimelineChart")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_HistoricalStatusDialog = _resolveComponent("HistoricalStatusDialog")!

  return (_ctx.equipment)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_card, { class: "q-mb-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row justify-between card-title flex-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, " (PI tag: " + _toDisplayString(_ctx.getEquipmentDetails?.parentTag === null
                ? "NA"
                : _ctx.getEquipmentDetails?.parentTag) + ") ", 1 /* TEXT */)
                ]),
                (!_ctx.isUserUnknownOrGuest())
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      outline: "",
                      rounded: "",
                      "no-caps": "",
                      label: "Add a historical status",
                      class: "main-button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (
            _ctx.displayHistoricalStatusDialog({
              displayHistoricalStatusDialog: true,
              isEditMode: false,
            })
          ))
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_q_separator),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_StatusTimelineChart, { onOnClickTimelineStatus: _ctx.onClickTimelineStatus }, null, 8 /* PROPS */, ["onOnClickTimelineStatus"])
              ])
            ]),
            (_ctx.currentSelectedStatus && !_ctx.isUserUnknownOrGuest())
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.statusInfo) + " ", 1 /* TEXT */),
                    _createElementVNode("b", null, [
                      _hoisted_9,
                      (_ctx.equipmentRunningHours !== 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.equipmentRunningHours) + " hours ", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (_ctx.equipmentRunningMinutes !== 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.equipmentRunningMinutes) + " minutes", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      _hoisted_12
                    ])
                  ]),
                  _createVNode(_component_q_btn, {
                    outline: "",
                    rounded: "",
                    "no-caps": "",
                    label: "Update Status",
                    class: "q-ml-xl q-mb-xl main-button",
                    onClick: _ctx.onUpdateStatusClick
                  }, null, 8 /* PROPS */, ["onClick"]),
                  _createVNode(_component_q_btn, {
                    outline: "",
                    rounded: "",
                    "no-caps": "",
                    label: "Delete Status",
                    class: "q-ml-xl q-mb-xl main-button",
                    onClick: _ctx.onDeleteStatusClick
                  }, null, 8 /* PROPS */, ["onClick"]),
                  _createVNode(_component_ConfirmDialog, {
                    title: _ctx.confirmPopUpTitle,
                    message: _ctx.confirmDeleteMessage,
                    open: _ctx.displayConfirmDialog,
                    "data-test": "button-close",
                    onOnClose: _ctx.onClose,
                    onOnConfirm: _ctx.onDelete
                  }, null, 8 /* PROPS */, ["title", "message", "open", "onOnClose", "onOnConfirm"])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_HistoricalStatusDialog, { status: _ctx.currentSelectedStatus }, null, 8 /* PROPS */, ["status"])
      ]))
    : _createCommentVNode("v-if", true)
}